import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import Banner from "./components/Banner/Index";
import Enquiry from './components/Forms/Enquiry'
import Container from './components/Container/Index';
import Title from './components/Title/Index'
import { CallSharp, Email, LocationOn } from '@mui/icons-material';
import { API_BASE_URL } from './Utils/useApi';

const Contact = () => {
  const [contactData, setContactData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/contact.php`);
        setContactData(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading)
    return (
      <div className="preloader flex-center">
        <CircularProgress size={24} />
      </div>
    );
  if (error) return <div>Error: An error occurred while fetching data</div>;
  if (!contactData) return null;

  const { bannerData } = contactData;
  return (
    <>
      {bannerData && <Banner Data={bannerData} />}
      <Container containerClass={'pt-5 mt-5 border-top float-end'} _parentClass={'ContactDetails d-none'}>
        <div className='col-lg-10 col-11 m-auto mt-lg-5'>
          <div className='row'>
            <div className='col-lg-3 col-sm-6 col-12 '>
              <div className='contactDetail'>
                <span className='fs-2 fw-100'>T</span>
                <p><a href="tel:918146788888">+91-81467 88888</a></p>
              </div>
            </div>
            <div className='col-lg-3 col-sm-6 col-12 '>
              <div className='contactDetail'>
                <span className='fs-2 fw-100'>E</span>
                <p><a href="mailto:iec.chandigarh@iecgensets.com">iec.chandigarh@iecgensets.com</a></p>
              </div>
            </div>
            <div className='col-lg-4 col-sm-6 col-12 '>
              <div className='contactDetail'>
                <span className='fs-2 fw-100'>A</span>
                <p><strong className='text-uppercase'>Corporate Address</strong><br />IEC Electric Power Limited<br /> S.C.O. 36, Sector 26, Madhya Marg<br /> Chandigarh - 160019 </p>
              </div>
              <div className='contactDetail'>
                <p><strong className='text-uppercase'>Factory Address</strong><br />Plot No. 1-6A, IID Centre<br />SICOP, Govindsar<br />Kathua - 184102 (J&K)</p>
              </div>
            </div>
            <div className='col-lg-2 col-sm-6 col-12'>
              <div className='contactDetail'>
                <span className='fs-2 fw-100'>M</span>
                <p><a href="https://maps.app.goo.gl/WmfiMmrtpVQKASLT7" target="_blank" rel="noreferrer">View Location Map</a></p>
              </div>
            </div>
          </div>
        </div>
      </Container>
      {contactData.contact &&
        <Container containerClass={'float-end'} _parentClass={'p-100'}>
          <div className='web-container'>
            <Title firstHeading={'IEC Electric Power Limited'} secondHeading={'Our Network'} />
            <div className='col-12 float-start'>
              <div className='row'>
                {contactData.contact.map((items, index) => (
                  <div className='col-lg-6 col-12' key={index}>
                    <div className="Networkcart border bg-white p-md-4 p-3">
                      {items.title &&
                        <Title secondHeading={items.title} _secondHeading={'fs-2'} _class={'mb-3 justify-content-start text-start'} />
                      }
                      <ul>
                        {items.address && <li className='d-flex gap-2'><span><LocationOn /></span><p dangerouslySetInnerHTML={{ __html: items.address }} /></li>}
                        {items.phone &&
                          <li className='d-flex gap-2'><span><CallSharp /> </span><p><a href={`tel:${items.phone.replace(/\D/g, '')}`}>{items.phone}</a></p></li>
                        }
                        {items.email &&
                          <li className='d-flex gap-2'><span><Email /> </span><p><a href={`mailto:${items.email}`}>{items.email}</a></p></li>
                        }
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Container>
      }
      {contactData.branches &&
        <Container _parentClass={'branches'} containerClass={'float-end p-100 bg-gray'}>
          <Title firstHeading={'Branches'} />
          <div className='col-lg-11 col-12 m-auto'>
            <div className='row justify-content-center'>
              {contactData.branches.map((items, index) => (
                <div className='cardPostion' key={index}>
                  <div className="Networkcart border bg-white p-md-4 p-3">
                    <Title secondHeading={items.title} _secondHeading={'fw-bold fs-4'} _class={'mb-2'} />
                    <ul>
                      {items.address &&
                        <li className='d-flex gap-2'><span><LocationOn /></span><p className="col-10 float-end" dangerouslySetInnerHTML={{ __html: items.address }} /></li>
                      }
                      {items.phone && <li className='d-flex gap-2'><span><CallSharp /></span><p className="col-10 float-end" ><a href={`tel:${items.phone.replace(/\D/g, '')}`}>{items.phone}</a></p></li>
                      }
                      {items.email &&
                        <li className='d-flex gap-2'><span><Email /></span><p className="col-10 float-end"><a href={`mailto:${items.email}`}>{items.email}</a></p></li>
                      }
                    </ul>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </Container>
      }
      <Enquiry />
    </>
  )
}

export default Contact